import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule } from '@angular/router';

@NgModule({
    imports: [
        RouterModule.forRoot([], {
            preloadingStrategy: PreloadAllModules,
            // onSameUrlNavigation: 'ignore',
            onSameUrlNavigation: 'reload'
        }),
    ],
    exports: [
        RouterModule
    ]
})
export class AppRoutingModule { }